import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import CostOfCashCalculator from "@/components/CostOfCashCalculator";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";
import { Clock, Banknote, ShieldAlert, TrendingUp } from "lucide-react";

export default function CostOfCashPage() {
  return (
    <div>
      <SEOHead title="Cost of Cash Calculator" description="Discover the hidden cost of handling cash in your business. Calculate labour, banking fees, and losses — then see how card payments can save you money." path="/cost-of-cash" />

      <section className="py-10 md:py-16 bg-gray-50" id="calculator" data-testid="calculator-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-2">Cost of Cash</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">How much is cash really costing you?</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Bank trips, counting time, deposit fees, shrinkage — it all adds up. See the real figure instantly.</p>
          </div>
          <CostOfCashCalculator />
        </div>
      </section>

      <TrustBar />

      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-brand-black mb-8">Where cash costs you</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { icon: Clock, title: "Staff time", desc: "Hours every week spent counting, reconciling, and banking." },
              { icon: Banknote, title: "Banking fees", desc: "Most banks charge a percentage to deposit cash." },
              { icon: ShieldAlert, title: "Shrinkage & theft", desc: "Cash goes missing — card payments leave a full audit trail." },
              { icon: TrendingUp, title: "Opportunity cost", desc: "Time handling cash is time not spent on growth." },
            ].map((item) => (
              <div key={item.title} className="bg-gray-50 border border-brand-light-grey rounded-2xl p-5">
                <item.icon size={22} className="text-brand-pink mb-3" />
                <h3 className="font-heading font-bold text-brand-black mb-1 text-sm">{item.title}</h3>
                <p className="text-xs text-brand-grey leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-8">
            <Link to="/switch-and-save#calculator" className="text-sm text-brand-aqua font-semibold hover:text-brand-aqua-dark transition-colors">Compare with card processing costs &rarr;</Link>
          </div>
        </div>
      </section>

      <RelatedTools currentPath="/cost-of-cash" />
      <SolutionsCrossSell currentPath="/cost-of-cash" />
    </div>
  );
}
